export const FlightBookingStatus = [
    { name: 'APPROVED', code: 'APPROVED' },
    { name: 'PENDING', code: 'PENDING' },
    { name: 'CANCELLED', code: 'CANCELLED' },
]